import Lottie from "react-lottie"
import styled from "styled-components"
import animationData from "./loading.json"

const LoadingCenterWrapper = styled.div`
  position: fixed;
  width: 100%;
  max-width: var(--app-max-width);
  height: 98%;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 9999;
  top: 0;
`

const LoadingCenterContent = styled.div<{ $backgroundColor: string }>`
  border-radius: var(--spacing_m, 12px);
  background: ${(props) => props.$backgroundColor};
  display: flex;
  padding: var(--spacing_s, 8px);
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 88px;
  height: 88px;
`

const LoadingCenter = ({
  backgroundColor = "var(--Primitive-White, #fff)",
}: {
  backgroundColor?: string
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }
  return (
    <LoadingCenterWrapper>
      <LoadingCenterContent $backgroundColor={backgroundColor}>
        <Lottie options={defaultOptions} />
      </LoadingCenterContent>
    </LoadingCenterWrapper>
  )
}

export default LoadingCenter
